<script>
  import { fetchAllBlocks } from "./toolbox.js";
  import Layout from "./Layout.svelte";

</script>

{#await fetchAllBlocks()}
<p>loading...</p>

{:then blocks}
<Layout blocks={blocks} />

{:catch error}
<p>Something went wrong: {error.message}</p>

{/await}
